import { ControlInterface } from '../../types/FormJson';
import { ReduxComponentInterface } from '../../../../types/Global';
import { Dispatch } from 'redux';
const { Button } = window.Edocat.Components;

import { transitionSubmit } from '../../actions/form';

interface TransitionsProps extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
}

class Transitions extends React.PureComponent<TransitionsProps> {
	onClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, formInstanceId, name, value, onChange, innerFormInstanceId } = this.props;
		onChange([name], value, true);
		actions.transitionSubmit(formInstanceId, true, innerFormInstanceId);
	};

	render() {
		const { value, disabled } = this.props;

		return (
			<div className={`form-row row-${name}`}>
				<Button label={value.split('|')[1]} onClick={this.onClick} disabled={disabled} />
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ transitionSubmit }, dispatch),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(Transitions);
